import { Popup, Tabs, Accordion, Form, Form_CoreInit, Carousel_CoreInit, Mobile, TRANSITION_END } from './core'
import Header from './modules/header'
import './plugins/google-map'
import './plugins/je-suis-fan'
import './plugins/pastille'
import './plugins/book-description'
import './plugins/checkout'

Popup.init()

Carousel_CoreInit([
  {
    classSelector: 'carousel--custom carousel--style--carousel-book',
    swiperOptions: {
      spaceBetween: 0,
      breakpoints: {
        0: {
          spaceBetween: 0,
        },
        768: {
          spaceBetween: 0,
        },
      },
    },
  },
])

Form_CoreInit([
  {
    classSelector: 'builder-form',
    formOptions: {
      floating_labels: false,
      file_input: false,
    },
  },
])

$(function() {
  /* Header */
  Header.init()

  /* Tabs */
  Tabs.init()

  $('.grid--style--product--description').each(function() {
    $(this).bookDescription()
  })

  $('.grid--postitem__product').each(function() {
    $(this).pastille()
  })

  $('.user-action-fan').each(function() {
    $(this).jeSuisFan()
  })

  $('.variations_form .single_add_to_cart_button').each(function() {
    $(this).addToCartButton()
  })

  /* Mobile filters on shop page */
  $('.action-mobile-filters').each(function(evt) {
    $(this).toggleForm($('.mobile-filters'))
  })

  /* Newsletter */
  $("form.newsletter-subscribe").on("submit", function(){
		$("p.success").slideUp("fast");
		var newsletter_email = $("input[name=newsletter_email]").val(),
			self = $(this);
		if (newsletter_email != ""){
			self.addClass("saving");
			jQuery.ajax({
				type: "post",
				dataType: "json",
				url: self.attr("action"),
				data: {
					action: "newsletter",
					newsletter_email: newsletter_email
				},
				success: function(response) {
					if (response.success){
						self.removeClass("saving").addClass("saved");
						if (self.hasClass("in-footer")){
							$("input[name=newsletter_email]").val("").blur();
							var successMessage = $("<p class='success'><strong>Inscription à l'infolettre réussie! Merci.</strong></p>").hide();
							self.append(successMessage);
							successMessage.slideDown();
						}
					} else {
						self.removeClass("saving");
						$("input[name=newsletter_email]").val("");
					}
				}
			});
		}
		return false;
	});
})
